/**
 * @param {import('@aws-sdk/client-chime-sdk-messaging').ChannelMessage} message
 */
export function extractUserIdFromMessage(message) {
  const userId = message.Sender?.Arn?.replace(/.+\//g, "");
  if (userId.indexOf("aws") === -1) {
    return userId;
  }
}
